import { displayMinutesAsHoursMinutes } from '@/helpers/dateHelper';
import { EmployeeSchedule } from '@/services/employee/schedule/schedule.types';

export interface ScheduleSummary {
  timeWorked: string;
  daysWorked: number;
  plannedAbsences: number;
}

export const calculateScheduleSummary = (schedule: EmployeeSchedule): ScheduleSummary => {
  const days = Object.values(schedule);

  const totalMinutesWorked = days.reduce((total, day) => {
    const dayMinutes = day.shifts.reduce((sum, shift) => sum + (shift.end - shift.start) / 60, 0);
    return total + dayMinutes;
  }, 0);

  const daysWorked = days.filter(day => day.shifts.length > 0).length;
  const plannedAbsences = days.filter(day => !!day.leaveType).length;

  return {
    timeWorked: displayMinutesAsHoursMinutes(Math.round(totalMinutesWorked)),
    daysWorked,
    plannedAbsences
  };
};
